<template>
	<div class="page">
		<!-- 移动端菜单 -->
		<div class="mobile-menu" v-if="isMobile">
			<el-select v-model="menuIndex" placeholder="选择协议" @change="selectMenu" style="width: 100%">
				<el-option
					v-for="(item,index) in menuList"
					:key="item.id || index"
					:label="item.name"
					:value="index"
				/>
			</el-select>
		</div>

		<div class="layout-container">
			<!-- 桌面端菜单 -->
			<div class="desktop-menu" v-if="!isMobile && !isSmallDesktop">
				<div class="menu-header">
					<i class="el-icon-document"></i>
					<span>协议列表</span>
				</div>
				<el-menu 
					:default-active="menuIndex.toString()" 
					@select="selectMenu"
					class="side-menu"
				>
					<el-menu-item 
						v-for="(item,index) in menuList" 
						:key="item.id || index"
						:index="index.toString()"
						:class="{'active-menu': menuIndex === index}"
					>
						<span>{{ item.name }}</span>
					</el-menu-item>
				</el-menu>
			</div>

			<!-- 主要内容区 -->
			<div class="content-area" :class="{'compact-layout': isSmallDesktop}">
				<!-- 预览面板 -->
				<div class="preview-panel" :class="{'compact-panel': isSmallDesktop}">
					<div class="panel-header">
						<div class="title">
							<i class="el-icon-view"></i>
							<span>实时预览</span>
						</div>
						<el-radio-group v-model="show" :size="radioSize">
							<el-radio-button label="phone">
								<i class="el-icon-mobile-phone"></i>H5
							</el-radio-button>
							<el-radio-button label="pc">
								<i class="el-icon-monitor"></i>PC
							</el-radio-button>
						</el-radio-group>
					</div>

					<div class="preview-content" v-if="currentItem">
						<!-- 手机预览 -->
						<div class="mobile-view" v-show="show === 'phone'">
							<div class="path-info">
								<el-tag :size="tagSize" class="path-tag">
									<i class="el-icon-link"></i>
									访问路径: /pages/common/agreement?id={{ currentItem.id }}
								</el-tag>
							</div>
							<div class="phone-container">
								<div class="phone-mockup">
									<div class="phone-notch"></div>
									<div class="phone-screen">
										<div class="phone-content" v-html="currentItem.content"></div>
									</div>
								</div>
							</div>
						</div>

						<!-- PC预览 -->
						<div class="desktop-view" v-show="show === 'pc'">
							<!-- PC预览的访问路径 -->
							<div class="path-info">
								<el-tag :size="tagSize" class="path-tag">
									<i class="el-icon-link"></i>
									访问路径: /pages/common/agreement?id={{ currentItem.id }}
								</el-tag>
							</div>
							<div class="browser-mockup">
								<div class="browser-header">
									<div class="browser-dots">
										<span class="dot red"></span>
										<span class="dot yellow"></span>
										<span class="dot green"></span>
									</div>
									<div class="browser-url">{{ currentItem.name }}</div>
								</div>
								<div class="browser-content" v-html="currentItem.content"></div>
							</div>
						</div>
					</div>

					<div class="empty-state" v-else>
						<el-empty :description="emptyDescription" :image-size="emptyImageSize">
							<div class="empty-tip">选择左侧协议或新增协议开始编辑</div>
						</el-empty>
					</div>
				</div>

				<!-- 编辑面板 -->
				<div class="editor-panel" :class="{'compact-panel': isSmallDesktop}">
					<div class="panel-header">
						<div class="title">
							<i class="el-icon-edit"></i>
							<span>内容编辑</span>
							<el-tag v-if="currentItem" class="edit-tag" type="primary" :size="tagSize">
								{{ currentItem.name }}
							</el-tag>
						</div>
						<div class="editor-actions">
							<el-button 
								type="primary" 
								icon="el-icon-check" 
								@click="ActionSave"
								:disabled="!currentItem"
								:size="buttonSize"
								class="save-btn"
							>
								保存
							</el-button>
						</div>
					</div>

					<div class="editor-container">
						<page-editor 
							v-if="currentItem"
							:height="editorHeight" 
							v-model="currentItem.content"
							class="rich-editor"
						/>
						<div class="editor-placeholder" v-else>
							<el-empty description="请选择协议进行编辑" :image-size="emptyImageSize">
								<el-button type="primary" @click="dialogVisible = true" icon="el-icon-plus" :size="buttonSize">
									新增协议
								</el-button>
							</el-empty>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- 操作按钮 -->
		<div class="action-bar">
			<el-button 
				type="primary" 
				icon="el-icon-plus" 
				@click="dialogVisible = true"
				:size="buttonSize"
				class="add-btn"
			>
				新增协议
			</el-button>
			<el-button 
				type="danger" 
				icon="el-icon-delete" 
				@click="ActionDel(currentItem.id)"
				v-if="currentItem && currentItem.id > 5"
				:size="buttonSize"
				class="delete-btn"
			>
				删除
			</el-button>
		</div>

		<!-- 新增对话框 -->
		<el-dialog 
			title="新增协议" 
			:visible.sync="dialogVisible" 
			:width="dialogWidth"
			:close-on-click-modal="false"
			class="add-dialog"
		>
			<div class="dialog-content">
				<div class="dialog-icon">
					<i class="el-icon-document-add"></i>
				</div>
				<div class="dialog-title">创建新协议</div>
				<el-form>
					<el-form-item>
						<el-input 
							v-model="form.name" 
							placeholder="请输入协议标题"
							maxlength="50"
							show-word-limit
							:size="inputSize"
							class="dialog-input"
						/>
					</el-form-item>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="resetForm" :size="buttonSize" class="cancel-btn">取消</el-button>
				<el-button 
					type="primary" 
					@click="ActionAdd" 
					:loading="adding"
					:size="buttonSize"
					class="confirm-btn"
				>
					{{ adding ? '创建中...' : '确认创建' }}
				</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				menuIndex: 0,
				menuList: [],
				dialogVisible: false,
				form: {},
				show: 'phone',
				adding: false,
				screenWidth: document.documentElement.clientWidth
			};
		},
		computed: {
			currentItem() {
				return this.menuList[this.menuIndex] || null;
			},
			// 屏幕尺寸检测
			isMobile() {
				return this.screenWidth < 768;
			},
			isSmallMobile() {
				return this.screenWidth < 400;
			},
			isSmallDesktop() {
				return this.screenWidth >= 768 && this.screenWidth < 1024;
			},
			isMediumDesktop() {
				return this.screenWidth >= 1024 && this.screenWidth < 1280;
			},
			isDesktop() {
				return this.screenWidth >= 1200;
			},
			// 尺寸计算
			editorHeight() {
				if (this.isSmallMobile) return 250;
				if (this.isMobile) return 280;
				if (this.isSmallDesktop) return 380;
				if (this.isMediumDesktop) return 420;
				if (this.isDesktop) return 550;
				return 450;
			},
			buttonSize() {
				if (this.isSmallMobile) return 'mini';
				if (this.isMobile || this.isSmallDesktop || this.isMediumDesktop) return 'small';
				return 'medium';
			},
			radioSize() {
				if (this.isSmallMobile) return 'mini';
				if (this.isMobile || this.isSmallDesktop || this.isMediumDesktop) return 'small';
				return 'medium';
			},
			tagSize() {
				if (this.isSmallMobile || this.isSmallDesktop || this.isMediumDesktop) return 'mini';
				if (this.isMobile) return 'small';
				return 'medium';
			},
			inputSize() {
				if (this.isSmallMobile || this.isSmallDesktop || this.isMediumDesktop) return 'small';
				if (this.isMobile) return 'small';
				return 'medium';
			},
			previewHeight() {
				if (this.isSmallMobile) return '240px';
				if (this.isMobile) return '280px';
				if (this.isSmallDesktop) return '320px';
				if (this.isMediumDesktop) return '380px';
				if (this.isDesktop) return '600px';
				return '500px';
			},
			phoneMockupHeight() {
				if (this.isSmallMobile) return '320px';
				if (this.isMobile) return '350px';
				if (this.isSmallDesktop) return '380px';
				if (this.isMediumDesktop) return '420px';
				return '600px';
			},
			phoneMockupWidth() {
				if (this.isSmallMobile) return '180px';
				if (this.isMobile) return '200px';
				if (this.isSmallDesktop) return '220px';
				if (this.isMediumDesktop) return '240px';
				return '280px';
			},
			dialogWidth() {
				if (this.isSmallMobile) return '320px';
				if (this.isMobile) return '350px';
				if (this.isSmallDesktop) return '380px';
				return '400px';
			},
			emptyImageSize() {
				if (this.isSmallMobile) return 60;
				if (this.isMobile || this.isSmallDesktop || this.isMediumDesktop) return 70;
				return 80;
			},
			emptyDescription() {
				if (this.isSmallMobile || this.isMobile) return "请选择协议查看预览";
				return "请选择协议查看预览";
			}
		},
		mounted() {
			this.LoadDatas();
			window.addEventListener('resize', this.handleResize);
			this.disableBodyScroll();
		},
		beforeDestroy() {
			window.removeEventListener('resize', this.handleResize);
			this.enableBodyScroll();
		},
		methods: {
			handleResize() {
				this.screenWidth = document.documentElement.clientWidth;
			},
			// 禁用body滚动
			disableBodyScroll() {
				if (this.isMobile) {
					document.body.style.overflow = 'hidden';
					document.documentElement.style.overflow = 'hidden';
				}
			},
			// 启用body滚动
			enableBodyScroll() {
				document.body.style.overflow = '';
				document.documentElement.style.overflow = '';
			},
			ActionDel(id) {
				if (!id) return;
				
				this.$confirm('确定要删除这个协议吗？', '提示', {
					confirmButtonText: '确定删除',
					cancelButtonText: '再想想',
					type: 'warning',
					confirmButtonClass: 'el-button--danger'
				}).then(() => {
					this.$load();
					this.$del('app-agreement/' + id).then(res => {
						this.$load(false);
						this.$success('删除成功');
						this.LoadDatas();
					}).catch(err => {
						this.$load(false);
						this.$warning(err);
					});
				}).catch(() => {});
			},
			ActionAdd() {
				if (!this.form.name || !this.form.name.trim()) {
					this.$warning('请输入协议标题');
					return;
				}

				this.adding = true;
				this.$post('app-agreement', this.form).then(res => {
					this.resetForm();
					this.menuList.push(res.data);
					this.menuIndex = this.menuList.length - 1;
					this.dialogVisible = false;
					this.adding = false;
					this.$success('创建成功');
				}).catch(err => {
					this.adding = false;
					this.$warning(err);
				});
			},
			LoadDatas() {
				this.$get('app-agreement', {
					_page: 0,
					_isreverse: 0,
					_order: 'id'
				}).then(res => {
					this.menuIndex = 0;
					this.menuList = res.data || [];
				}).catch(err => {
					this.$warning(err);
					this.menuList = [];
				});
			},
			ActionSave() {
				if (!this.currentItem) return;
				
				this.$load();
				this.$save('app-agreement', this.currentItem).then(res => {
					this.$load(false);
					this.$success('保存成功');
				}).catch(err => {
					this.$load(false);
					this.$warning(err);
				});
			},
			selectMenu(index) {
				this.menuIndex = parseInt(index);
			},
			resetForm() {
				this.form = {};
				this.dialogVisible = false;
				this.adding = false;
			}
		}
	};
</script>

<style lang="scss" scoped>
.page {
	min-height: 100vh;
	background: linear-gradient(135deg, #f5f7ff 0%, #f0f4ff 100%);
	padding: 20px;
	position: relative;
	padding-bottom: 100px;
	
	/* 移动端禁用页面滚动 */
	@media (max-width: 767px) {
		height: 100vh;
		overflow: hidden;
		padding: 12px;
		padding-bottom: 100px;
		font-size: 14px;
	}
	
	/* 超小屏幕进一步调整 */
	@media (max-width: 400px) {
		padding: 8px;
		padding-bottom: 90px;
		font-size: 13px;
	}
	
	/* 小桌面端调整 */
	@media (min-width: 768px) and (max-width: 1023px) {
		padding: 15px;
		padding-bottom: 100px;
		font-size: 14px;
	}

	/* 中等桌面端调整（笔记本） */
	@media (min-width: 1024px) and (max-width: 1279px) {
		padding: 18px;
		padding-bottom: 100px;
		font-size: 14px;
	}
}

// 移动端菜单
.mobile-menu {
	margin-bottom: 12px;
	
	/* 超小屏幕菜单调整 */
	@media (max-width: 400px) {
		margin-bottom: 8px;
	}
	
	/* 小桌面端菜单调整 */
	@media (min-width: 768px) and (max-width: 1023px) {
		margin-bottom: 15px;
	}
	
	::v-deep .el-select {
		.el-input__inner {
			border: 1px solid #e1e8ff;
			border-radius: 6px;
			background: white;
			font-size: 14px;
			height: 36px;
			line-height: 36px;
			
			/* 超小屏幕输入框调整 */
			@media (max-width: 400px) {
				height: 32px;
				line-height: 32px;
				font-size: 13px;
				border-radius: 4px;
			}
			
			/* 小桌面端输入框调整 */
			@media (min-width: 768px) and (max-width: 1023px) {
				height: 34px;
				line-height: 34px;
				font-size: 13px;
			}
		}
	}
}

// 布局容器
.layout-container {
	display: flex;
	gap: 20px;
	min-height: calc(100vh - 200px);
	
	/* 移动端布局调整 */
	@media (max-width: 767px) {
		height: calc(100vh - 140px);
		overflow: hidden;
		flex-direction: column;
		min-height: auto;
		gap: 12px;
	}
	
	/* 超小屏幕布局调整 */
	@media (max-width: 400px) {
		height: calc(100vh - 120px);
		gap: 8px;
	}
	
	/* 小桌面端布局调整 */
	@media (min-width: 768px) and (max-width: 1023px) {
		gap: 15px;
		min-height: calc(100vh - 180px);
	}

	/* 中等桌面端布局调整（笔记本） */
	@media (min-width: 1024px) and (max-width: 1279px) {
		gap: 18px;
		min-height: calc(100vh - 190px);
	}

	/* 大屏幕布局优化 */
	@media (min-width: 1600px) {
		gap: 30px;
	}
}

// 桌面端菜单 - 小桌面端隐藏
.desktop-menu {
	width: 260px;
	flex-shrink: 0;
	background: white;
	border-radius: 12px;
	box-shadow: 0 4px 20px rgba(91, 140, 255, 0.1);
	border: 1px solid #e1e8ff;
	
	/* 大屏幕菜单宽度调整 */
	@media (min-width: 1600px) {
		width: 280px;
	}
	
	/* 小桌面端隐藏菜单 */
	@media (min-width: 768px) and (max-width: 1023px) {
		display: none;
	}

	/* 中等桌面端菜单调整 */
	@media (min-width: 1024px) and (max-width: 1279px) {
		width: 240px;
	}
	
	.menu-header {
		padding: 20px;
		border-bottom: 1px solid #f0f4ff;
		font-weight: 600;
		color: #2c3e50;
		font-size: 16px;
		display: flex;
		align-items: center;
		gap: 8px;
		
		i {
			color: #5B8CFF;
			font-size: 18px;
		}
	}
	
	.side-menu {
		border: none;
		padding: 10px;
		
		.el-menu-item {
			height: 48px;
			line-height: 48px;
			margin: 4px 0;
			border-radius: 8px;
			display: flex;
			align-items: center;
			gap: 10px;
			transition: all 0.3s ease;
			font-size: 14px;
			
			i {
				color: #909399;
				font-size: 16px;
			}
			
			&:hover {
				background: #f8faff;
				color: #5B8CFF;
				
				i {
					color: #5B8CFF;
				}
			}
			
			&.active-menu {
				background: linear-gradient(135deg, #5B8CFF 0%, #7ba4ff 100%);
				color: white;
				box-shadow: 0 2px 8px rgba(91, 140, 255, 0.3);
				
				i {
					color: white;
				}
			}
		}
	}
}

// 内容区域
.content-area {
	flex: 1;
	display: flex;
	gap: 20px;
	
	/* 大屏幕内容区域调整 */
	@media (min-width: 1600px) {
		gap: 30px;
	}
	
	/* 移动端内容区域调整 */
	@media (max-width: 767px) {
		flex-direction: column;
		height: 100%;
		overflow: hidden;
		flex: 1;
		gap: 12px;
	}
	
	/* 超小屏幕内容区域调整 */
	@media (max-width: 400px) {
		gap: 8px;
	}
	
	/* 小桌面端紧凑布局 */
	&.compact-layout {
		gap: 15px;
		
		@media (min-width: 768px) and (max-width: 1023px) {
			flex-direction: column;
			height: 100%;
		}
	}

	/* 中等桌面端内容区域调整 */
	@media (min-width: 1024px) and (max-width: 1279px) {
		gap: 18px;
	}
}

// 预览面板和编辑面板通用样式
.preview-panel,
.editor-panel {
	flex: 1;
	background: white;
	border-radius: 10px;
	box-shadow: 0 4px 15px rgba(91, 140, 255, 0.1);
	border: 1px solid #e1e8ff;
	display: flex;
	flex-direction: column;
	min-height: 600px;
	
	/* 大屏幕面板高度调整 */
	@media (min-width: 1200px) {
		min-height: 700px;
		border-radius: 12px;
	}
	
	/* 移动端面板调整 */
	@media (max-width: 767px) {
		min-height: auto;
		flex: 1;
		overflow: hidden;
		height: 100%;
		max-height: 50vh;
		border-radius: 8px;
	}
	
	/* 超小屏幕面板调整 */
	@media (max-width: 400px) {
		border-radius: 6px;
		max-height: 45vh;
	}
	
	/* 小桌面端紧凑面板 */
	&.compact-panel {
		@media (min-width: 768px) and (max-width: 1023px) {
			min-height: 500px;
			border-radius: 8px;
		}
	}

	/* 中等桌面端面板调整 */
	@media (min-width: 1024px) and (max-width: 1279px) {
		min-height: 550px;
		border-radius: 10px;
	}
	
	.panel-header {
		padding: 12px 16px;
		border-bottom: 1px solid #f0f4ff;
		display: flex;
		justify-content: space-between;
		align-items: center;
		flex-shrink: 0;
		
		/* 移动端头部调整 */
		@media (max-width: 767px) {
			padding: 10px 12px;
		}
		
		/* 超小屏幕头部调整 */
		@media (max-width: 400px) {
			padding: 8px 10px;
		}
		
		/* 小桌面端头部调整 */
		@media (min-width: 768px) and (max-width: 1023px) {
			padding: 10px 14px;
		}

		/* 中等桌面端头部调整 */
		@media (min-width: 1024px) and (max-width: 1279px) {
			padding: 12px 16px;
		}
		
		.title {
			font-weight: 600;
			color: #2c3e50;
			font-size: 15px;
			display: flex;
			align-items: center;
			gap: 6px;
			
			/* 超小屏幕标题调整 */
			@media (max-width: 400px) {
				font-size: 14px;
				gap: 4px;
			}
			
			/* 小桌面端标题调整 */
			@media (min-width: 768px) and (max-width: 1023px) {
				font-size: 14px;
				gap: 5px;
			}

			/* 中等桌面端标题调整 */
			@media (min-width: 1024px) and (max-width: 1279px) {
				font-size: 15px;
				gap: 6px;
			}
			
			i {
				color: #5B8CFF;
				font-size: 16px;
				
				/* 超小屏幕图标调整 */
				@media (max-width: 400px) {
					font-size: 14px;
				}
				
				/* 小桌面端图标调整 */
				@media (min-width: 768px) and (max-width: 1023px) {
					font-size: 15px;
				}

				/* 中等桌面端图标调整 */
				@media (min-width: 1024px) and (max-width: 1279px) {
					font-size: 16px;
				}
			}
		}
		
		.edit-tag {
			background: linear-gradient(135deg, #5B8CFF 0%, #7ba4ff 100%);
			border: none;
			color: white;
			margin-left: 8px;
			font-size: 12px;
			height: 22px;
			line-height: 20px;
			padding: 0 6px;
			
			/* 超小屏幕标签调整 */
			@media (max-width: 400px) {
				font-size: 11px;
				height: 20px;
				line-height: 18px;
				padding: 0 4px;
				margin-left: 6px;
			}
			
			/* 小桌面端标签调整 */
			@media (min-width: 768px) and (max-width: 1023px) {
				font-size: 11px;
				height: 20px;
				line-height: 18px;
				padding: 0 5px;
			}

			/* 中等桌面端标签调整 */
			@media (min-width: 1024px) and (max-width: 1279px) {
				font-size: 12px;
				height: 22px;
				line-height: 20px;
				padding: 0 6px;
			}
		}
	}
}

// 预览内容
.preview-content {
	flex: 1;
	padding: 12px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: flex-start;
	gap: 12px;
	overflow: auto;
	
	/* 大屏幕预览内容调整 */
	@media (min-width: 1200px) {
		padding: 20px;
		gap: 20px;
	}
	
	/* 移动端预览内容调整 */
	@media (max-width: 767px) {
		padding: 10px;
		gap: 10px;
		overflow: auto;
		height: calc(100% - 44px);
		flex: 1;
	}
	
	/* 超小屏幕预览内容调整 */
	@media (max-width: 400px) {
		padding: 8px;
		gap: 8px;
		height: calc(100% - 40px);
	}
	
	/* 小桌面端预览内容调整 */
	@media (min-width: 768px) and (max-width: 1023px) {
		padding: 10px;
		gap: 10px;
		height: calc(100% - 44px);
	}

	/* 中等桌面端预览内容调整 */
	@media (min-width: 1024px) and (max-width: 1279px) {
		padding: 15px;
		gap: 15px;
		height: calc(100% - 48px);
	}
}

// 路径信息通用样式
.path-info {
	width: 100%;
	display: flex;
	justify-content: center;
	margin-bottom: 8px;
	
	/* 移动端路径信息调整 */
	@media (max-width: 767px) {
		margin-bottom: 6px;
	}
	
	/* 小桌面端路径信息调整 */
	@media (min-width: 768px) and (max-width: 1023px) {
		margin-bottom: 7px;
	}

	/* 中等桌面端路径信息调整 */
	@media (min-width: 1024px) and (max-width: 1279px) {
		margin-bottom: 8px;
	}
}

.path-tag {
	background: #f0f7ff;
	border: 1px solid #d6e7ff;
	color: #5B8CFF;
	font-size: 11px;
	flex-shrink: 0;
	height: 24px;
	line-height: 22px;
	padding: 0 8px;
	
	/* 超小屏幕路径标签调整 */
	@media (max-width: 400px) {
		font-size: 10px;
		padding: 0 6px;
		height: 22px;
		line-height: 20px;
	}
	
	/* 小桌面端路径标签调整 */
	@media (min-width: 768px) and (max-width: 1023px) {
		font-size: 10px;
		height: 22px;
		line-height: 20px;
		padding: 0 7px;
	}

	/* 中等桌面端路径标签调整 */
	@media (min-width: 1024px) and (max-width: 1279px) {
		font-size: 11px;
		height: 24px;
		line-height: 22px;
		padding: 0 8px;
	}
	
	i {
		margin-right: 4px;
		font-size: 10px;
		
		/* 超小屏幕图标调整 */
		@media (max-width: 400px) {
			margin-right: 3px;
			font-size: 9px;
		}
		
		/* 小桌面端图标调整 */
		@media (min-width: 768px) and (max-width: 1023px) {
			margin-right: 3px;
			font-size: 9px;
		}

		/* 中等桌面端图标调整 */
		@media (min-width: 1024px) and (max-width: 1279px) {
			margin-right: 4px;
			font-size: 10px;
		}
	}
}

// 手机预览
.mobile-view {
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 10px;
	width: 100%;
	height: 100%;
	
	/* 大屏幕手机预览调整 */
	@media (min-width: 1200px) {
		gap: 20px;
	}
	
	/* 移动端手机预览调整 */
	@media (max-width: 767px) {
		gap: 8px;
		height: 100%;
		justify-content: flex-start;
	}

	/* 中等桌面端手机预览调整 */
	@media (min-width: 1024px) and (max-width: 1279px) {
		gap: 12px;
	}
}

// 手机容器 - 新增容器确保手机预览完整显示
.phone-container {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	height: 100%;
	max-height: calc(100% - 50px); /* 为路径标签留出空间 */
	overflow: auto;
	padding: 10px;

	/* 移动端手机容器调整 */
	@media (max-width: 767px) {
		padding: 8px;
		max-height: calc(100% - 40px);
	}

	/* 中等桌面端手机容器调整 */
	@media (min-width: 1024px) and (max-width: 1279px) {
		padding: 12px;
		max-height: calc(100% - 45px);
	}
}

.phone-mockup {
	width: v-bind(phoneMockupWidth);
	height: v-bind(phoneMockupHeight);
	background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%);
	border-radius: 20px;
	padding: 10px;
	position: relative;
	box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
	flex-shrink: 0;
	
	/* 大屏幕手机尺寸调整 */
	@media (min-width: 1200px) {
		width: 320px;
		height: 650px;
		border-radius: 25px;
		padding: 12px;
	}
	
	/* 移动端手机尺寸调整 */
	@media (max-width: 767px) {
		box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
	}
	
	/* 超小屏幕手机尺寸调整 */
	@media (max-width: 400px) {
		padding: 8px;
		border-radius: 16px;
	}
	
	/* 小桌面端手机尺寸调整 */
	@media (min-width: 768px) and (max-width: 1023px) {
		width: 220px;
		height: 380px;
		border-radius: 18px;
		padding: 9px;
	}

	/* 中等桌面端手机尺寸调整 */
	@media (min-width: 1024px) and (max-width: 1279px) {
		width: 240px;
		height: 420px;
		border-radius: 20px;
		padding: 10px;
	}
	
	.phone-notch {
		width: 90px;
		height: 20px;
		background: #1a1a1a;
		border-radius: 30px;
		position: absolute;
		top: 0;
		left: 50%;
		transform: translateX(-50%);
		
		/* 大屏幕凹槽调整 */
		@media (min-width: 1200px) {
			width: 120px;
			height: 25px;
			border-radius: 40px;
		}
		
		/* 超小屏幕凹槽调整 */
		@media (max-width: 400px) {
			width: 80px;
			height: 16px;
			border-radius: 20px;
		}
		
		/* 小桌面端凹槽调整 */
		@media (min-width: 768px) and (max-width: 1023px) {
			width: 85px;
			height: 18px;
			border-radius: 25px;
		}

		/* 中等桌面端凹槽调整 */
		@media (min-width: 1024px) and (max-width: 1279px) {
			width: 90px;
			height: 20px;
			border-radius: 30px;
		}
	}
	
	.phone-screen {
		width: 100%;
		height: 100%;
		background: white;
		border-radius: 15px;
		padding: 12px;
		overflow-y: auto;
		box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
		
		/* 大屏幕屏幕内边距调整 */
		@media (min-width: 1200px) {
			padding: 15px;
			border-radius: 20px;
		}
		
		/* 超小屏幕屏幕内边距调整 */
		@media (max-width: 400px) {
			padding: 10px;
			border-radius: 12px;
		}
		
		/* 小桌面端屏幕内边距调整 */
		@media (min-width: 768px) and (max-width: 1023px) {
			padding: 10px;
			border-radius: 14px;
		}

		/* 中等桌面端屏幕内边距调整 */
		@media (min-width: 1024px) and (max-width: 1279px) {
			padding: 12px;
			border-radius: 16px;
		}
		
		/* 隐藏手机屏幕滚动条 */
		&::-webkit-scrollbar {
			width: 0;
			display: none;
		}
		
		-ms-overflow-style: none;
		scrollbar-width: none;
	}
}

// PC预览
.desktop-view {
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: flex-start;
	gap: 12px;
	
	/* 大屏幕PC预览调整 */
	@media (min-width: 1200px) {
		gap: 15px;
	}
	
	/* 移动端PC预览调整 */
	@media (max-width: 767px) {
		gap: 10px;
	}

	/* 中等桌面端PC预览调整 */
	@media (min-width: 1024px) and (max-width: 1279px) {
		gap: 12px;
	}
	
	.browser-mockup {
		width: 100%;
		height: v-bind(previewHeight);
		border: 1px solid #e1e8ff;
		border-radius: 6px;
		overflow: hidden;
		box-shadow: 0 4px 15px rgba(91, 140, 255, 0.1);
		
		/* 大屏幕浏览器预览调整 */
		@media (min-width: 1200px) {
			max-width: 900px;
			border-radius: 8px;
		}
		
		/* 超小屏幕浏览器预览调整 */
		@media (max-width: 400px) {
			height: 220px;
			border-radius: 4px;
		}
		
		/* 小桌面端浏览器预览调整 */
		@media (min-width: 768px) and (max-width: 1023px) {
			height: 350px;
			border-radius: 6px;
		}

		/* 中等桌面端浏览器预览调整 */
		@media (min-width: 1024px) and (max-width: 1279px) {
			height: 380px;
			border-radius: 7px;
		}
		
		.browser-header {
			height: 32px;
			background: #f8faff;
			display: flex;
			align-items: center;
			padding: 0 12px;
			border-bottom: 1px solid #e1e8ff;
			gap: 8px;
			
			/* 超小屏幕浏览器头部调整 */
			@media (max-width: 400px) {
				height: 28px;
				padding: 0 10px;
				gap: 6px;
			}
			
			/* 小桌面端浏览器头部调整 */
			@media (min-width: 768px) and (max-width: 1023px) {
				height: 30px;
				padding: 0 11px;
				gap: 7px;
			}

			/* 中等桌面端浏览器头部调整 */
			@media (min-width: 1024px) and (max-width: 1279px) {
				height: 32px;
				padding: 0 12px;
				gap: 8px;
			}
			
			.browser-dots {
				display: flex;
				gap: 5px;
				
				.dot {
					width: 8px;
					height: 8px;
					border-radius: 50%;
					
					/* 超小屏幕圆点调整 */
					@media (max-width: 400px) {
						width: 6px;
						height: 6px;
					}
					
					/* 小桌面端圆点调整 */
					@media (min-width: 768px) and (max-width: 1023px) {
						width: 7px;
						height: 7px;
					}

					/* 中等桌面端圆点调整 */
					@media (min-width: 1024px) and (max-width: 1279px) {
						width: 8px;
						height: 8px;
					}
					
					&.red { background: #ff5f57; }
					&.yellow { background: #ffbd2e; }
					&.green { background: #28ca42; }
				}
			}
			
			.browser-url {
				flex: 1;
				text-align: center;
				color: #5B8CFF;
				font-size: 12px;
				font-weight: 500;
				
				/* 大屏幕URL字体调整 */
				@media (min-width: 1200px) {
					font-size: 14px;
				}
				
				/* 超小屏幕URL调整 */
				@media (max-width: 400px) {
					font-size: 11px;
				}
				
				/* 小桌面端URL调整 */
				@media (min-width: 768px) and (max-width: 1023px) {
					font-size: 11px;
				}

				/* 中等桌面端URL调整 */
				@media (min-width: 1024px) and (max-width: 1279px) {
					font-size: 12px;
				}
			}
		}
		
		.browser-content {
			height: calc(100% - 32px);
			padding: 15px;
			overflow-y: auto;
			background: white;
			
			/* 大屏幕内容区域调整 */
			@media (min-width: 1200px) {
				padding: 20px;
				height: calc(100% - 40px);
			}
			
			/* 移动端内容区域调整 */
			@media (max-width: 767px) {
				padding: 12px;
			}
			
			/* 超小屏幕内容区域调整 */
			@media (max-width: 400px) {
				padding: 10px;
				height: calc(100% - 28px);
			}
			
			/* 小桌面端内容区域调整 */
			@media (min-width: 768px) and (max-width: 1023px) {
				padding: 12px;
				height: calc(100% - 30px);
			}

			/* 中等桌面端内容区域调整 */
			@media (min-width: 1024px) and (max-width: 1279px) {
				padding: 15px;
				height: calc(100% - 32px);
			}
			
			/* 隐藏浏览器内容滚动条 */
			&::-webkit-scrollbar {
				width: 0;
				display: none;
			}
			
			-ms-overflow-style: none;
			scrollbar-width: none;
		}
	}
}

// 编辑器容器
.editor-container {
	flex: 1;
	padding: 0 12px 12px 12px;
	display: flex;
	flex-direction: column;
	
	/* 大屏幕编辑器容器调整 */
	@media (min-width: 1200px) {
		padding: 0 20px 20px;
	}
	
	/* 移动端编辑器容器调整 */
	@media (max-width: 767px) {
		padding: 0 10px 10px;
		height: calc(100% - 44px);
		overflow: hidden;
		flex: 1;
	}
	
	/* 超小屏幕编辑器容器调整 */
	@media (max-width: 400px) {
		padding: 0 8px 8px;
		height: calc(100% - 40px);
	}
	
	/* 小桌面端编辑器容器调整 */
	@media (min-width: 768px) and (max-width: 1023px) {
		padding: 0 10px 10px;
		height: calc(100% - 44px);
	}

	/* 中等桌面端编辑器容器调整 */
	@media (min-width: 1024px) and (max-width: 1279px) {
		padding: 0 15px 15px;
		height: calc(100% - 48px);
	}
	
	.rich-editor {
		border: 1px solid #e1e8ff;
		border-radius: 6px;
		overflow: hidden;
		flex: 1;
		
		/* 大屏幕富文本编辑器调整 */
		@media (min-width: 1200px) {
			height: 550px !important;
			border-radius: 8px;
		}
		
		/* 移动端富文本编辑器调整 */
		@media (max-width: 767px) {
			height: 100% !important;
			min-height: 200px;
		}
		
		/* 超小屏幕富文本编辑器调整 */
		@media (max-width: 400px) {
			min-height: 180px;
			border-radius: 4px;
		}
		
		/* 小桌面端富文本编辑器调整 */
		@media (min-width: 768px) and (max-width: 1023px) {
			min-height: 320px;
			border-radius: 6px;
		}

		/* 中等桌面端富文本编辑器调整 */
		@media (min-width: 1024px) and (max-width: 1279px) {
			min-height: 380px;
			border-radius: 6px;
		}
	}
	
	.editor-placeholder {
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 20px;
		flex: 1;
		
		/* 超小屏幕占位符调整 */
		@media (max-width: 400px) {
			padding: 15px;
		}
		
		/* 小桌面端占位符调整 */
		@media (min-width: 768px) and (max-width: 1023px) {
			padding: 18px;
		}

		/* 中等桌面端占位符调整 */
		@media (min-width: 1024px) and (max-width: 1279px) {
			padding: 20px;
		}
	}
}

// 空状态
.empty-state {
	flex: 1;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 20px 12px;
	
	/* 超小屏幕空状态调整 */
	@media (max-width: 400px) {
		padding: 15px 10px;
	}
	
	/* 小桌面端空状态调整 */
	@media (min-width: 768px) and (max-width: 1023px) {
		padding: 18px 12px;
	}

	/* 中等桌面端空状态调整 */
	@media (min-width: 1024px) and (max-width: 1279px) {
		padding: 20px 15px;
	}
	
	.empty-tip {
		margin-top: 6px;
		color: #909399;
		font-size: 12px;
		
		/* 超小屏幕提示文字调整 */
		@media (max-width: 400px) {
			font-size: 11px;
			margin-top: 4px;
		}
		
		/* 小桌面端提示文字调整 */
		@media (min-width: 768px) and (max-width: 1023px) {
			font-size: 11px;
			margin-top: 5px;
		}

		/* 中等桌面端提示文字调整 */
		@media (min-width: 1024px) and (max-width: 1279px) {
			font-size: 12px;
			margin-top: 6px;
		}
	}
}

// 操作按钮栏
.action-bar {
	position: fixed;
	bottom: 15px;
	left: 50%;
	transform: translateX(-50%);
	background: white;
	padding: 8px 16px;
	border-radius: 18px;
	box-shadow: 0 4px 20px rgba(91, 140, 255, 0.2);
	border: 1px solid #e1e8ff;
	display: flex;
	gap: 8px;
	z-index: 1000;
	
	/* 移动端操作按钮调整 */
	@media (max-width: 767px) {
		width: 90%;
		bottom: 12px;
		flex-direction: row;
		justify-content: center;
		gap: 6px;
		padding: 6px 12px;
		border-radius: 16px;
	}
	
	/* 超小屏幕操作按钮调整 */
	@media (max-width: 400px) {
		width: 92%;
		bottom: 10px;
		padding: 5px 10px;
		border-radius: 14px;
		gap: 5px;
	}
	
	/* 小桌面端操作按钮调整 */
	@media (min-width: 768px) and (max-width: 1023px) {
		width: 85%;
		bottom: 15px;
		padding: 7px 14px;
		border-radius: 16px;
		gap: 7px;
	}

	/* 中等桌面端操作按钮调整 */
	@media (min-width: 1024px) and (max-width: 1279px) {
		width: 80%;
		bottom: 15px;
		padding: 8px 16px;
		border-radius: 18px;
		gap: 8px;
	}
	
	.add-btn {
		background: linear-gradient(135deg, #5B8CFF 0%, #7ba4ff 100%);
		border: none;
		border-radius: 16px;
		padding: 6px 12px;
		box-shadow: 0 2px 8px rgba(91, 140, 255, 0.3);
		font-size: 12px;
		height: 32px;
		
		/* 超小屏幕按钮调整 */
		@media (max-width: 400px) {
			border-radius: 14px;
			padding: 4px 10px;
			font-size: 11px;
			height: 28px;
		}
		
		/* 小桌面端按钮调整 */
		@media (min-width: 768px) and (max-width: 1023px) {
			border-radius: 15px;
			padding: 5px 11px;
			font-size: 11px;
			height: 30px;
		}

		/* 中等桌面端按钮调整 */
		@media (min-width: 1024px) and (max-width: 1279px) {
			border-radius: 16px;
			padding: 6px 12px;
			font-size: 12px;
			height: 32px;
		}
		
		&:hover {
			background: linear-gradient(135deg, #4a7dff 0%, #6a96ff 100%);
			transform: translateY(-1px);
			box-shadow: 0 3px 10px rgba(91, 140, 255, 0.4);
		}
	}
	
	.delete-btn {
		border-radius: 16px;
		padding: 6px 12px;
		font-size: 12px;
		height: 32px;
		
		/* 超小屏幕删除按钮调整 */
		@media (max-width: 400px) {
			border-radius: 14px;
			padding: 4px 10px;
			font-size: 11px;
			height: 28px;
		}
		
		/* 小桌面端删除按钮调整 */
		@media (min-width: 768px) and (max-width: 1023px) {
			border-radius: 15px;
			padding: 5px 11px;
			font-size: 11px;
			height: 30px;
		}

		/* 中等桌面端删除按钮调整 */
		@media (min-width: 1024px) and (max-width: 1279px) {
			border-radius: 16px;
			padding: 6px 12px;
			font-size: 12px;
			height: 32px;
		}
	}
}

// 对话框样式
.add-dialog {
	::v-deep .el-dialog {
		border-radius: 12px;
		box-shadow: 0 15px 40px rgba(91, 140, 255, 0.15);
		border: none;
		
		/* 移动端对话框调整 */
		@media (max-width: 767px) {
			width: 92% !important;
			margin-top: 8vh !important;
			border-radius: 10px;
		}
		
		/* 超小屏幕对话框调整 */
		@media (max-width: 400px) {
			width: 94% !important;
			margin-top: 6vh !important;
			border-radius: 8px;
		}
		
		/* 小桌面端对话框调整 */
		@media (min-width: 768px) and (max-width: 1023px) {
			width: 380px !important;
			margin-top: 10vh !important;
			border-radius: 10px;
		}

		/* 中等桌面端对话框调整 */
		@media (min-width: 1024px) and (max-width: 1279px) {
			width: 380px !important;
			margin-top: 10vh !important;
			border-radius: 10px;
		}
		
		.el-dialog__header {
			display: none;
		}
		
		.el-dialog__body {
			padding: 0;
		}
		
		.el-dialog__footer {
			padding: 12px 20px 20px;
			border-top: 1px solid #f0f4ff;
			
			/* 超小屏幕底部调整 */
			@media (max-width: 400px) {
				padding: 10px 15px 15px;
			}
			
			/* 小桌面端底部调整 */
			@media (min-width: 768px) and (max-width: 1023px) {
				padding: 12px 18px 18px;
			}

			/* 中等桌面端底部调整 */
			@media (min-width: 1024px) and (max-width: 1279px) {
				padding: 12px 20px 20px;
			}
		}
	}
	
	.dialog-content {
		padding: 25px 20px 20px;
		text-align: center;
		
		/* 超小屏幕内容调整 */
		@media (max-width: 400px) {
			padding: 20px 15px 15px;
		}
		
		/* 小桌面端内容调整 */
		@media (min-width: 768px) and (max-width: 1023px) {
			padding: 22px 18px 18px;
		}

		/* 中等桌面端内容调整 */
		@media (min-width: 1024px) and (max-width: 1279px) {
			padding: 25px 20px 20px;
		}
		
		.dialog-icon {
			width: 45px;
			height: 45px;
			background: linear-gradient(135deg, #5B8CFF 0%, #7ba4ff 100%);
			border-radius: 50%;
			display: flex;
			align-items: center;
			justify-content: center;
			margin: 0 auto 12px;
			
			/* 超小屏幕图标调整 */
			@media (max-width: 400px) {
				width: 40px;
				height: 40px;
				margin-bottom: 10px;
			}
			
			/* 小桌面端图标调整 */
			@media (min-width: 768px) and (max-width: 1023px) {
				width: 42px;
				height: 42px;
				margin-bottom: 11px;
			}

			/* 中等桌面端图标调整 */
			@media (min-width: 1024px) and (max-width: 1279px) {
				width: 45px;
				height: 45px;
				margin-bottom: 12px;
			}
			
			i {
				font-size: 22px;
				color: white;
				
				/* 超小屏幕图标大小调整 */
				@media (max-width: 400px) {
					font-size: 20px;
				}
				
				/* 小桌面端图标大小调整 */
				@media (min-width: 768px) and (max-width: 1023px) {
					font-size: 21px;
				}

				/* 中等桌面端图标大小调整 */
				@media (min-width: 1024px) and (max-width: 1279px) {
					font-size: 22px;
				}
			}
		}
		
		.dialog-title {
			font-size: 15px;
			font-weight: 600;
			color: #2c3e50;
			margin-bottom: 15px;
			
			/* 超小屏幕标题调整 */
			@media (max-width: 400px) {
				font-size: 14px;
				margin-bottom: 12px;
			}
			
			/* 小桌面端标题调整 */
			@media (min-width: 768px) and (max-width: 1023px) {
				font-size: 14px;
				margin-bottom: 13px;
			}

			/* 中等桌面端标题调整 */
			@media (min-width: 1024px) and (max-width: 1279px) {
				font-size: 15px;
				margin-bottom: 15px;
			}
		}
		
		.dialog-input {
			::v-deep .el-input__inner {
				height: 38px;
				border-radius: 6px;
				border: 1px solid #e1e8ff;
				text-align: center;
				font-size: 13px;
				
				/* 超小屏幕输入框调整 */
				@media (max-width: 400px) {
					height: 36px;
					font-size: 12px;
					border-radius: 4px;
				}
				
				/* 小桌面端输入框调整 */
				@media (min-width: 768px) and (max-width: 1023px) {
					height: 36px;
					font-size: 12px;
					border-radius: 5px;
				}

				/* 中等桌面端输入框调整 */
				@media (min-width: 1024px) and (max-width: 1279px) {
					height: 38px;
					font-size: 13px;
					border-radius: 6px;
				}
				
				&:focus {
					border-color: #5B8CFF;
					box-shadow: 0 0 0 2px rgba(91, 140, 255, 0.1);
				}
			}
		}
	}
	
	.dialog-footer {
		display: flex;
		justify-content: center;
		gap: 10px;
		
		/* 超小屏幕底部按钮调整 */
		@media (max-width: 400px) {
			gap: 8px;
		}
		
		/* 小桌面端底部按钮调整 */
		@media (min-width: 768px) and (max-width: 1023px) {
			gap: 9px;
		}

		/* 中等桌面端底部按钮调整 */
		@media (min-width: 1024px) and (max-width: 1279px) {
			gap: 10px;
		}
		
		.cancel-btn {
			width: 80px;
			border-radius: 4px;
			border: 1px solid #dcdfe6;
			font-size: 12px;
			height: 32px;
			
			/* 超小屏幕取消按钮调整 */
			@media (max-width: 400px) {
				width: 70px;
				font-size: 11px;
				height: 30px;
			}
			
			/* 小桌面端取消按钮调整 */
			@media (min-width: 768px) and (max-width: 1023px) {
				width: 75px;
				font-size: 11px;
				height: 30px;
			}

			/* 中等桌面端取消按钮调整 */
			@media (min-width: 1024px) and (max-width: 1279px) {
				width: 80px;
				font-size: 12px;
				height: 32px;
			}
		}
		
		.confirm-btn {
			width: 80px;
			background: linear-gradient(135deg, #5B8CFF 0%, #7ba4ff 100%);
			border: none;
			border-radius: 4px;
			font-size: 12px;
			height: 32px;
			
			/* 超小屏幕确认按钮调整 */
			@media (max-width: 400px) {
				width: 70px;
				font-size: 11px;
				height: 30px;
			}
			
			/* 小桌面端确认按钮调整 */
			@media (min-width: 768px) and (max-width: 1023px) {
				width: 75px;
				font-size: 11px;
				height: 30px;
			}

			/* 中等桌面端确认按钮调整 */
			@media (min-width: 1024px) and (max-width: 1279px) {
				width: 80px;
				font-size: 12px;
				height: 32px;
			}
			
			&:hover {
				background: linear-gradient(135deg, #4a7dff 0%, #6a96ff 100%);
			}
		}
	}
}

// 保存按钮
.save-btn {
	background: linear-gradient(135deg, #5B8CFF 0%, #7ba4ff 100%);
	border: none;
	border-radius: 4px;
	font-size: 12px;
	height: 28px;
	padding: 0 12px;
	
	/* 超小屏幕保存按钮调整 */
	@media (max-width: 400px) {
		font-size: 11px;
		height: 26px;
		padding: 0 10px;
	}
	
	/* 小桌面端保存按钮调整 */
	@media (min-width: 768px) and (max-width: 1023px) {
		font-size: 11px;
		height: 26px;
		padding: 0 11px;
	}

	/* 中等桌面端保存按钮调整 */
	@media (min-width: 1024px) and (max-width: 1279px) {
		font-size: 12px;
		height: 28px;
		padding: 0 12px;
	}
	
	&:hover {
		background: linear-gradient(135deg, #4a7dff 0%, #6a96ff 100%);
	}
}

/* 全局隐藏滚动条样式 */
.hide-scrollbar {
	&::-webkit-scrollbar {
		width: 0;
		display: none;
	}
	
	-ms-overflow-style: none;
	scrollbar-width: none;
}
</style>